import Moment from "moment";

/**
 * Enumeration statusProject
 * Statut d'avancement du projet (en cours, livré ...)
 */
export enum StatusProject {
  InProgress = "InProgress",
  Deliver = "Deliver"
}
/**
 * Enumeration PrestationStatus
 * Etat de la prestation
 */
export enum PrestationStatus {
  Draft = "Draft",
  Modelisation = "Modelisation",
  Graphics = "Graphics",
  Changing = "Changing",
  WaitPov = "WaitPov",
  WaitValidClient = "WaitValidClient",
  Valid = "Valid",
  WaitValidInternal = "WaitValidInternal",
  Delivery = "Delivery"
}
/**
 * Enumeration ProposalType
 * Une prestation passe par plusieurs propositions pouvant changer de type
 * exemple : on a validé une proposition "pov", une nouvelle proposition pour la même prestation est faite mais avec
 * le type "artwork"
 */
export enum ProposalType {
  /* Choix d'un Point de vue proposé */
  POV = "POV",
  /* La Proposition peut être commenté */
  Artwork = "Artwork",
  /* Choix de la décoration de la proposition */
  PlanDecoration = "PlanDecoration"
}
/**
 * Enumeration ResponseTypes
 * Le type de la réponse d'une proposition est définit par l'utilisateur
 * exemple : l'utilisateur peut rejeter une proposition, la réponse sera donc "rejected"
 */
export enum ResponseTypes {
  Rejected = "Rejected",
  Validated = "Validated",
  Pending = "Pending"
}
/**
 * Enumeration ProposalStatus
 * Correspond à la réponse d'un utilisateur à une proposition
 * en attente si aucune réponse
 */
export enum ProposalStatus {
  Pending = "Pending",
  Validated = "Validated",
  Rejected = "Rejected"
}

/**
 * Enumeration PrestationActionStatus
 * Correspond au niveau d'importance d'une action
 * Le status est la comparaison entre la date du jour
 * et de la date à laquelle doit être fait l'action
 */
export enum PrestationActionStatus {
  Low = "Low",
  Medium = "Medium",
  Hight = "Hight"
}
/**
 * Project
 * Un projet est un ensemble de prestations
 */
export interface Project {
  /* Project id */
  id: number;
  /* Project reference */
  refArka: string;
  /* Project name */
  name: string;
  /* Project city */
  city: string;
  /* nb prestation */
  prestationCount: number;
  /* enumeration of StatusProject */
  status: StatusProject;
  /* project's prestations list exemple(mass plan, artwork)  */
  prestations: Prestation[];
  isLoadingPrestations: boolean;

  /* project manager */
  projectManager?: ProjectManager;
  /* project thumb url */
  image?: string;
  /* contains number of project's prestations, pov and artwork*/
  projectStats: ProjectStats;
  /* contains  all action in progress for all prestations */
  prestationsAction: PrestationAction[];

  /* Archived projects may contain a financial year (exercice comptable) */
  financialYear?: string;
}

/**
 * Project Manager
 */
interface ProjectManager {
  /* Manager id */
  id: number;
  /* Manager firstname */
  firstname: string;
  /* Manager lastname */
  lastname: string;
  /* Manager phone */
  phone?: string;
  /* manager email */
  email: string;
}

/**
 * Prestation
 * A prestation is an artwork, mass plan ....
 */
export interface Prestation {
  /* Prestation id */
  id: number;
  /* Une prestation peut avoir plusieurs status: pending, delivered, etc... */
  status: PrestationStatus;
  /* Prestation name */
  name: string;
  /* Delivery date */
  dueDate: Moment.Moment;
  /* prestation's proposal list  */
  proposals: Proposal[];
  isLoadingProposals: boolean;
  /*  media of prestation: it's the final offer, can not be rejected.  */
  delivery?: string;
  /* livraison id for download link */
  deliveryId?: number;
  /* thumbnail */
  image?: string;
  /* delivery image */
  imageDelivery?: string;
  url?: string;
  /** String corresponding to type of prestation (evimmo, illustration intérieur, ...) */
  type_prestation: string;
}

/**
 * PrestationAction
 */
export interface PrestationAction {
  auteur: string;
  type: string;
  uuid: string;
  date_crea: Moment.Moment;
  prestation_id: number;
  nom: string;
  thumbUrl: string;
  type_prestation: string;
  status: PrestationActionStatus;
  prestation?: Prestation;
  proposalStatus: number;
}
/**
 * ProjectStats
 */

export interface ProjectStats {
  prestationsCount: number;
  validAngleCount: number;
  validIllustrationCount: number;
  decosCount: number;
}

/**
 * Proposal
 * Type générique pour les prospositions, sera implémenté dans les différents types de proposition (artwork, pov, ...)
 */

export interface GenericProposal {
  /* Proposal id */
  id: number;
  /* Proposal uuid */
  uuid: string;
  /* Proposal date */
  date: Moment.Moment;
  /* Proposal type */
  type: ProposalType;
  /* Person who made the proposal at arka */
  technician?: Technician;
  /* enumeration of StatusProposal */
  status: ProposalStatus;
  /* proposed resources */
  ressources: Ressource[];
  /* session round trip between client and hub */
  session: number;
}

/**
 * Technician
 * Le technicien va faire une proposition à une prestation
 */
interface Technician {
  /* Technician id */
  id: number;
  /* Technician firstname */
  firstname: string;
  /* Technician lastname */
  lastname: string;
}
/**
 * Ressource
 * Graphical work made by arka studio, which is submitted to our customer (artwork, point of views, ...)
 */

export interface Ressource {
  /* Ressource id */
  id: number;
  /* Ressource label */
  label: string;
  /* Ressource image */
  image: string;
  /* Vignette */
  thumb: string;
  /* Extra information following ressource type. E.g color for decoration */
  payload?: {
    color: any;
  };
}

/**
 * Response
 * The customer may accept, reject or comment the submitted proposal
 */

export interface GenericalResponse {
  /* Response id */
  id: number;
  /* Ressource id correspond au choix de la ressource pour un pov */
  ressourceId: number;
  /* Author id */
  authorId: number;
  /* Response date */
  date: Moment.Moment;
  /* enumeration of ResponseTypes */
  responseType: ResponseTypes;
}
/**
 * Comment
 * Comment made by a customer on an artwork. It shall be positionned on a 2D image
 */
export interface ProposalComment {
  /**
   * Comment id
   * Comment id can be prefix by "tmp-", if this case it's a temporary id
   */
  id: string;
  /* Coordinate X for the position of the comment in the illustration of the proposal */
  x: number;
  /* Coordinate Y for the position of the comment in the illustration of the proposal */
  y: number;
  /* Comment text */
  text: string;
  /* files attach to comment*/
  files: AttachFile[];
}
/**
 * AttachFile
 */
export interface AttachFile {
  id: number;
  filename: string;
  url: string;
}

/**
 * PayloadArtwork
 * Réponse de l'utilisateur si la proposition est de type artwork
 */
export interface PayloadArtwork {
  /* proposal's general comment */
  comment: string;
  /* list of proposal's comment */
  comments: ProposalComment[];
  /* request if you have consult all intervenant */
  askedEveryone: string;
  /* request if you have summarized all changement */
  summarizedEverything: string;
  /* files attach to proposal*/
  files: AttachFile[];
}

/**
 * PayloadPlanDecoration
 * Réponse de l'utilisateur si la proposition est de type planDecoration
 */
export interface PayloadPlanDecoration {
  /* proposal's comment */
  comment: string;
  /* request if you accepted cgv   */
  cgv: boolean;
  /* request if you have send the last version of your specifications, so we can make a proposal with up to date specifications */
  lastVersionTransmitted: boolean;
}
/**
 * PayloadPov
 * Réponse de l'utilisateur si la proposition est de type pov
 */
export interface PayloadPov {
  /* proposal's comment */
  comment: string;
  /* files attach to proposal*/
  files: AttachFile[];
}

/**
 * ResponseArtwork
 */
export interface ResponseArtwork extends GenericalResponse {
  payload: PayloadArtwork;
}

/**
 * ResponsePlanDecoration
 */
export interface ResponsePlanDecoration extends GenericalResponse {
  payload: PayloadPlanDecoration;
}
/**
 * ResponsePlanPov
 */
export interface ResponsePov extends GenericalResponse {
  payload?: PayloadPov;
}
/**
 * ProposalArtwork
 */
export interface ProposalArtwork extends GenericProposal {
  type: ProposalType.Artwork;
  responses: ResponseArtwork[];
  rank?: number;
}
/**
 * ProposalPlanDecoration
 */
export interface ProposalPlanDecoration extends GenericProposal {
  type: ProposalType.PlanDecoration;
  responses: ResponsePlanDecoration[];
}
/**
 * ProposalPOV
 */
export interface ProposalPOV extends GenericProposal {
  type: ProposalType.POV;
  responses: ResponsePov[];
}
export type ProposalResponse =
  | ResponseArtwork
  | ResponsePlanDecoration
  | ResponsePov;
export type Proposal = ProposalArtwork | ProposalPOV | ProposalPlanDecoration;

/**
 * State
 *
 */
export interface State {
  projects: Project[];
  isLoadingProjects: boolean;
}

export const initialState: State = {
  projects: [],
  isLoadingProjects: true
};



// WEBPACK FOOTER //
// ./src/redux/projects/state.ts